import React, { useState, useEffect, useMemo, useRef } from "react";
import { debounce } from "lodash";
import { convertCase } from "../../../SharedFiles/Helper/utils";
import QrContainer from "../../../SharedFiles/QRCode/qrReader";
import { toast, Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import CommonSearch from "../../../SharedFiles/CommonSearch/CommonSearch";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const DeliveryModal = ({
  modelOpen,
  setOpenManual,
  openManual,
  handleQrScan,
  editMode,
  setValues,
  values,
  handleSearchDrop,
  tableData,
  InProgress,
  onSubmit,
  handleCloseDialog,
  setErrorMessage,
  errorMessage,
}) => {
  const { Getitem, GetdeliveryList, PostDeliveryResponse, loading, error } =
    useSelector((state) => state.delivery);
 //batchsearch 
 const {t} = useTranslation();
 const batchsearch=['batch_Number'];
  const ModelSearchInput =
    Getitem && Getitem.length > 0
      ? Object.keys(Getitem[0]).filter(
          (key) =>
            key !== "absEntry" &&
            key !== "orderEntry" &&
            key !== "wbDocEntry" &&
            key !== "u_NOOFBUNDLES" &&
            key !== "u_QTYINNOS" &&
            key !== "u_QTYTORELEASE" && 
            key !=="deliveredQty"
        )
      : [];

  const inputfieldLabel = [
    "Kg",
    "quantity_Nos",
    "receipt_Type",
  ];
  const handleValueChange = (item,field) => {
    setErrorMessage({});
      setValues((prevValues) => ({
        ...prevValues,
        batch_Number: item.batch_Number,
        // Kg: item.quantity, 
        // quantity_Nos: item.quantity_Nos, 
        Kg: item.receipt_Type === 'LOOSE BAR' ? '' : item.quantity,
        quantity_Nos: item.receipt_Type === 'LOOSE BAR' ? '' : item.quantity_Nos,
        receipt_Type: item.receipt_Type,
        iWeight:item.iWeight,
      }));
  
  };

  const handleInputValueChange = (e, header) => {
    setErrorMessage({});
    const value = e.target.value;
    if (value === "") {
      setValues((prevState) => ({
        ...prevState,
        [header]: "",
      }));
      return;
    }
    if (header === "Kg") {
      const decimalPattern = /^\d{1,10}(\.\d{0,5})?$/;
      if (decimalPattern.test(value)) {
        setValues((prevValues) => ({
          ...prevValues,
          Kg: value,
        }));
      }
    }
    if (header === "quantity_Nos") {
      // const integerPattern = /^\d{1,10}+$/; // Regex to allow only integers
      const integerPattern = /^\d{1,10}$/;
      if (integerPattern.test(value)) {
        setValues((prevValues) => ({
          ...prevValues,
          quantity_Nos: parseInt(value, 10), // Ensures value is stored as an integer
        }));
      }
    }
  };

  const handleSubmit = () => {
    const submissionData = {
      item_Code: values.item_Code,
      description: values.description,
      batch_Number: values.batch_Number,
      quantity_Nos: values.quantity_Nos,
      Kg: values.Kg,
      receipt_Type: values.receipt_Type,
      Iweight:values.iWeight,
    };
    onSubmit(submissionData);
  };
  console.log("values",values);
  
  return (
    <Dialog open={modelOpen}>
      <DialogTitle className="Modal-heading">{t('Item Details')}</DialogTitle>
      <DialogContent className="custom-dialog-content">
        {openManual ? (
          <div>
            <CommonSearch
              inputFields={ModelSearchInput}
              data={Getitem}
              values={values}
              setValues={setValues}
              handleDropdownClick={handleSearchDrop}
              errorMessage={errorMessage}
            />
            {InProgress && InProgress.PickListItem && (
              <div className="d-grid">
                        <CommonSearch
                          inputFields={batchsearch}
                          data={GetdeliveryList}
                          values={values}
                          setValues={setValues}
                          errorMessage={errorMessage}
                          handleDropdownClick={handleValueChange}
                        />
                      {inputfieldLabel &&
                        inputfieldLabel.map((header, index) => (
                                <TextField
                        key={index}
                        label={t(convertCase(header))}
                        variant="outlined"
                        onChange={(e) => handleInputValueChange(e, header)}
                        className="custom-modal-textfield"
                        value={
                          values[header] !== undefined &&
                          values[header] !== null
                            ? values[header]
                            : ""
                        }
                        style={{ marginBottom: "10px" }}
                        disabled={
                          header === "Kg" ||
                          header === "quantity_Nos" ||
                          header === "receipt_Type"
                            ? values.receipt_Type !== "LOOSE BAR"
                            : false
                        }
                        error={errorMessage && errorMessage[header]}
                        helperText={errorMessage && errorMessage[header]}
                      />
                    )
                  )}
              </div>
            )}
          </div>
        ) : (
          <div>
            <QrContainer elementId="Delivery_Screen" openManual={openManual} onScan={handleQrScan} />
          </div>
        )}
      </DialogContent>
      <DialogActions className="custom-dialog-actions">
        <Button onClick={() => setOpenManual(!openManual)}>
          {openManual ? "Scanner" : "Manual"}
        </Button>
        <Button className="Modal-cancel" onClick={handleCloseDialog}>
          Cancel
        </Button>
        <Button
          className="Modal-submit"
          onClick={handleSubmit}
          // disabled={isSubmitDisabled}
        >
          {editMode ? "Update" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeliveryModal;
// import React, { useState, useEffect } from "react";
// import { debounce } from "lodash";
// import { commonFilter, convertCase } from "../SharedFiles/Helper/utils";
// import QrContainer from "../SharedFiles/QRCode/qrReader";
// import { toast } from "react-hot-toast";
// import { useSelector } from "react-redux";
// import CommonSearch from "../SharedFiles/CommonSearch/CommonSearch";
// import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from "@mui/material";

// const DeliveryModal = ({
//   modelOpen,
//   setOpenManual,
//   openManual,
//   handleQrScan,
//   editMode,
//   setValues,
//   values,
//   handleSearchDrop,
//   InProgress,
//   onSubmit,
//   handleCloseDialog,
//   setModelOpen,
//   errorMessage
// }) => {
//   const { Getitem, GetdeliveryList, loading, error } = useSelector((state) => state.Delivery);

//   // Itemcode search fields
//   const ModelSearchInput = Getitem && Getitem.length > 0
//     ? Object.keys(Getitem[0]).filter(
//         (key) =>
//           key !== "absEntry" &&
//           key !== "orderEntry" &&
//           key !== "wbDocEntry" &&
//           key !== "u_NOOFBUNDLES" &&
//           key !== "u_QTYINNOS" &&
//           key !== "u_QTYTORELEASE"
//       )
//     : [];

//   const inputfieldLabel = ['batchNum', 'Kg', 'u_QTYINNOS', 'u_RECEIPTTYPE'];

//   // States for dropdowns
//   const [filteredResults, setFilteredResults] = useState([]);
//   const [dropdownVisibility, setDropdownVisibility] = useState({});

//   const handleInputChange = (e, field) => {
//     const value = e.target.value;
//     setValues(prevValues => ({
//       ...prevValues,
//       [field]: value,
//     }));

//     // Filter the results based on the input value for batchNum
//     if (field === 'batchNum' && GetdeliveryList ) {
//       const filteredBatches = commonFilter(GetdeliveryList, field, value);
//       setFilteredResults(filteredBatches);
//       setDropdownVisibility(prevState => ({
//         ...prevState,
//         [field]: filteredBatches.length > 0, // Show dropdown if there are results
//       }));
//     }
//     else{
//       setFilteredResults(GetdeliveryList);
//     }
//   };

//   const handleValueChange = (selectedBatchNum, field) => {
//     const selectedBatch = GetdeliveryList.find(batch => batch.batchNum === selectedBatchNum);
//     if (selectedBatch) {
//       setValues(prevValues => ({
//         ...prevValues,
//         batchNum: selectedBatch.batchNum,
//         Kg: selectedBatch.quantity,
//         u_QTYINNOS: selectedBatch.u_QTYINNOS,
//         u_RECEIPTTYPE: selectedBatch.u_RECEIPTTYPE,
//       }));
//     }
//     // Hide the dropdown after selection
//     setDropdownVisibility(prevState => ({
//       ...prevState,
//       [field]: false,
//     }));
//   };

//   const handleInputClick = (field) => {
//     if (field === 'batchNum') {
//       // Show the dropdown only if there are filtered results
//       setDropdownVisibility(prevState => ({
//         ...prevState,
//         [field]: GetdeliveryList && GetdeliveryList.length > 0,  // Show if filtered results are available
//       }));
//     }
//   };

//   const handleSubmit = () => {
//     if (!values.item_Code) {
//       toast.error("Select Itemcode");
//       return;
//     }
//     if (!values.batchNum) {
//       toast.error("Select BatchNumber");
//       return;
//     }

//     const submissionData = {
//       item_Code: values.item_Code,
//       description: values.description,
//       batchNum: values.batchNum,
//       u_QTYINNOS: values.u_QTYINNOS,
//       Kg: values.Kg,
//       u_RECEIPTTYPE: values.u_RECEIPTTYPE
//     };
//     onSubmit(submissionData);
//     setModelOpen(false);
//   };

//   return (
//     <Dialog open={modelOpen}>
//       <DialogTitle className="Modal-heading">Item Details</DialogTitle>
//       <DialogContent className="custom-dialog-content">
//         {openManual ? (
//           <div>
//             <CommonSearch
//               inputFields={ModelSearchInput}
//               data={Getitem}
//               values={values}
//               setValues={setValues}
//               handleDropdownClick={handleSearchDrop}
//               errorMessage={errorMessage}
//             />
//             {InProgress && InProgress.PickListItem && (
//               <div className="d-grid">
//                 {inputfieldLabel && inputfieldLabel.map((header, index) =>
//                   header === "batchNum" ? (
//                     <TextField
//                       key={index}
//                       select
//                       label={convertCase(header)} // Label for the dropdown
//                       variant="outlined"
//                       value={values.batchNum || ""} // Controlled value
//                       // onChange={(e) => handleValueChange(e.target.value, header)} // Handle selection
//                       className="custom-modal-textfield"
//                       style={{ marginBottom: "10px" }}
//                       error={!!errorMessage[header]}
//                       onClick={() => handleInputClick(header)} // Show suggestions on click
//                     >
//                       {filteredResults.length > 0 ? (
//                         <ul className="custom-dropdown-list">
//                           {filteredResults.map((batch, batchIndex) => (
//                             <li
//                               key={batchIndex}
//                               value={batch.batchNum}
//                               onClick={() => handleValueChange(batch.batchNum, 'batchNum')}
//                               className="dropdown-item"
//                             >
//                               {batch.batchNum}
//                             </li>
//                           ))}
//                         </ul>
//                       ) : (
//                         <ul className="custom-dropdown-list">
//                           <li className="dropdown-item">No batches available</li>
//                         </ul>
//                       )}
//                     </TextField>
//                   ) : (
//                     <TextField
//                       key={index}
//                       label={convertCase(header)}
//                       variant="outlined"
//                       onChange={(e) => handleInputChange(e, header)} // Handle change dynamically
//                       className="custom-modal-textfield"
//                       value={values && values[header] !== null ? values[header] : ""}
//                       style={{ marginBottom: '10px' }}
//                       onClick={() => handleInputClick(header)} // Show suggestions on click
//                       disabled={header !== 'batchNum'} // Disable other fields unless batchNum
//                     />
//                   )
//                 )}
//               </div>
//             )}
//           </div>
//         ) : (
//           <div>
//             <QrContainer elementId="Delivery_Screen" onScan={handleQrScan} />
//           </div>
//         )}
//       </DialogContent>
//       <DialogActions className="custom-dialog-actions">
//         <Button onClick={() => setOpenManual(!openManual)}>
//           {openManual ? "Scanner" : "Manual"}
//         </Button>
//         <Button className="Modal-cancel" onClick={handleCloseDialog}>Cancel</Button>
//         <Button
//           className="Modal-submit"
//           onClick={handleSubmit}
//         >
//           {editMode ? "Update" : "Add"}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default DeliveryModal;
